import { Component, OnDestroy, OnInit } from "@angular/core";
import { ITaxReturn } from "../model/i-tax-return";
import { Subscription } from "rxjs";
import { TaxReturnsResolver } from "../../tax-returns-resolver";
import {
  IAnswer,
  IAnswerWarning,
  IFormField,
  makeControlForQuestion
} from "../../../../shared/components/form-field-wrapper/form-field-wrapper.component";
import { IAnswerFlag, ICommentField, IGroup, ISubGroup } from "../subcategory/subcategory";
import {
  AnswerService,
  CommentService,
  Question,
  SmartFormTypeService,
  TaxReturnService
} from "../../../../../swaggerServices";
import moment from "moment";
import { IComment } from "../subcategory/comments/comments.component";
import { UserInfoService } from "../../../user-info.service";
import { cloneDeep } from "lodash-es";
import {
  handleUrlsForNewComment,
  getActiveWarnings
} from "../../get-full-tax-return";
import { Category, Subcategory } from "../../../../../swaggerServices";
import { BaseURLService } from "../../../../shared/util/baseUrl.service";
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { TaxReturnSubcategoryService } from "../subcategory/subcategory.service";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { getVisibleQuestionsInSmartForms } from "../../../settings/smart-forms/smart-form-logic-utils";
import { ConfigStateService } from "../../../config/config-state.service";
import { CommentValue } from "../subcategory/comments/attachments/attachments.component";
import { AttachmentsService, Folders } from "../subcategory/comments/attachments/attachments.service";

interface IQuestionWithTaxStructureMeta extends IFormField {
  category?: Category;
  subcategory?: Subcategory;
  group?: IGroup;
  subgroup?: ISubGroup;
}

@Component({
    selector: "app-warnings",
    templateUrl: "./warnings.component.html",
    styleUrls: ["./warnings.component.scss"],
    providers: [
        {
            provide: TRANSLOCO_SCOPE,
            useValue: { scope: 'tax-returns', alias: 'taxReturns' },
        }
    ],
    standalone: false
})
export class WarningsComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  taxReturn?: ITaxReturn;
  taxReturnWithMissingInfo?: ITaxReturn;
  question: IQuestionWithTaxStructureMeta;
  hasWarnings = false;

  tab = 1; // default to warning tab
  formGroup: UntypedFormGroup;
  hasFlags = false;
  answerWarnings: any
  initAnswerFlags: any

  commentFields: ICommentField[] = [];
  comment: UntypedFormControl;
  subcategory: any
  comments = []
  documents: any
  isSavingReply: boolean; // when posting a comment reply

  columnOrdering = [];
  subGroup: ISubGroup;
  groupId: number

  smartForms: any = []
  visibleQuestions: any = {}
  showActiveAnswerWarnings = true;

  folders: Folders = {
    rootFolder: "",
    attachmentsFolder: "",
    targetFolder: "",
  };


  constructor(
    private baseUrl: BaseURLService,
    private taxReturnsResolver: TaxReturnsResolver,
    private userInfo: UserInfoService,
    private taxReturnService: TaxReturnService,
    private answerService: AnswerService,
    private commentService: CommentService,
    private smartFormService: SmartFormTypeService,
    private config: ConfigStateService,
    private taxReturnSubcategoryService: TaxReturnSubcategoryService,
    private attachmentsService: AttachmentsService,
  ) {}

  ngOnInit() {
    this.initTaxReturn()
  }

  initTaxReturn() {
    this.subscriptions.push(
      this.taxReturnsResolver
        .getTaxReturnObs()
        .subscribe((data: ITaxReturn) => {
          this.initMissingInfo(cloneDeep(data), 1);
        })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  initMissingInfo(taxReturn: ITaxReturn, tab) {
    this.hasWarnings = false
    this.taxReturn = taxReturn;
    this.taxReturnWithMissingInfo = taxReturn;
    this.attachmentsService.setRootFolder(this.folders, this.taxReturn.docshareRootFolder);

    if (this.config.featureFlags.enableOneteamIntegration) {
      this.smartFormService.getSmartFormsByTaxReturnId(this.taxReturn.id).subscribe((smartFormList: any) => {
        if (smartFormList?.length) {
          this.smartFormService.getSentSmartFormRequests(this.taxReturn.id).subscribe((smartFormRequest: any) => {
            smartFormList.forEach(sf => {
              if (smartFormRequest.some(r => r.smartFormTypeId === sf.id && r.otRequestId && r.syncDate)) {
                this.smartForms.push(sf)
              }
            })
            this.visibleQuestions = getVisibleQuestionsInSmartForms(this.smartForms)
          })
        }
      })
    }


    if (
      this.taxReturnWithMissingInfo &&
      this.taxReturnWithMissingInfo.categories &&
      this.taxReturnWithMissingInfo.categories.length
    ) {
      this.taxReturnWithMissingInfo.categories.forEach(cat => {
        if (
          !this.hasWarnings &&
          this.showitem(cat, tab) &&
          cat.subcategories &&
          cat.subcategories.length
        ) {
          cat.subcategories.forEach(subCat => {
            if (
              !this.hasWarnings &&
              this.showitem(subCat, tab) &&
              subCat.groups &&
              subCat.groups.length
            ) {
              subCat.groups.forEach(group => {
                if (
                  !this.hasWarnings &&
                  this.showitem(group, tab) &&
                  group.subgroups &&
                  group.subgroups.length
                ) {
                  group.subgroups.forEach(subGroup => {
                    if (
                      !this.hasWarnings &&
                      this.showitem(subGroup, tab) &&
                      subGroup.questions &&
                      subGroup.questions.length
                    ) {
                      subGroup.questions.forEach(question => {
                        if (tab === 1) {
                          if (
                            (this.hasValidationWarnings(cat, question) ||
                              this.hasMissingInfoWarnings(cat, question, tab)) &&
                            !this.hasWarnings
                          ) {
                            this.hasWarnings = true;
                          }
                        }else {
                          if ( this.hasMissingInfoWarnings(cat, question, tab) &&
                            !this.hasWarnings
                          ) {
                            this.hasWarnings = true;
                          }
                        }
                      });
                    }
                  });
                }
              });
            }
          });
        }
      });
    }
  }

  showitem(item: Category | Subcategory | IGroup | ISubGroup, tab) {
    switch (tab) {
      case 1: {
        return item &&
        this.showActiveAnswerWarnings ?
        ((item["validationWarnings"] && item["validationWarnings"].length > 0) || item["warningCount"]) :
        item["closedWarningCount"]
      }
      case 2: {
        return item &&
        this.showActiveAnswerWarnings ? item["flagCount"] : item["closedFlagCount"]
      }
      case 3: {
        return item &&
        item["commentCount"]
      }
      default: {
        return false;
      }
    }

  }

  hasValidationWarnings(category: Category, question: IFormField) {
    if (category && category["validationWarnings"]) {
      const found = category["validationWarnings"].find(
        w => w.id === question.id
      );
      return found ? true : false;
    }
    return false;
  }

  hasMissingInfoWarnings(category: Category, question: IFormField, tab: number) {
    let foundMissingInfoWarnings = false;
    if (
      category &&
      question &&
      question.answers &&
      question.answers.length
    ) {
      switch (tab) {
        case 1: {
          if (category["warningCount"]) {
            question.answers.forEach(a => {
              a.answerWarnings &&
              a.answerWarnings.forEach(aw => {
                if ((this.showActiveAnswerWarnings && aw.status === 0) || (!this.showActiveAnswerWarnings && aw.status > 0)) {
                  foundMissingInfoWarnings = true;
                }
              });
            });
          }
          break;
        }
        case 2: {
          if (category["flagCount"]) {
            question.answers.forEach(a => {
              a.answerFlags &&
              a.answerFlags.forEach(af => {
                if ((this.showActiveAnswerWarnings && af.status === 0) || (!this.showActiveAnswerWarnings && af.status > 0)) {
                  foundMissingInfoWarnings = true;
                }
              });
            });
          }
          break;
        }
        case 3: {
          if (category["commentCount"]) {
            question.answers.forEach(a => {
              a.comments &&
              a.comments.forEach(ac => {
                if (!(ac.parentCommentId || ac.answerWarningId || ac.answerFlagId)) {
                  foundMissingInfoWarnings = true;
                }
              });
            });
          }
          break;
        }
        default: {
          break;
        }
      }

    }
    return foundMissingInfoWarnings;
  }

  private updateColumnOrdering() {
    const questions: any[] = [...this.subGroup.questions.map(q => q)];
    questions.sort((a, b) => a.order - b.order);
    return questions;
  }

  selectQuestion(
    question: IFormField,
    category: Category,
    subcategory: Subcategory,
    group: IGroup,
    subgroup: ISubGroup,
    tab: number
  ) {
    this.formGroup = new UntypedFormGroup({});
    this.question = {
      ...question,
      category: category,
      subcategory: subcategory,
      group: group,
      subgroup: subgroup
    };

    this.subcategory = subcategory
    this.groupId = group.id
    this.subGroup = subgroup

    // tb column questions added later
    if (!subgroup.isTable) {
      const control = makeControlForQuestion(this.question);
      if (control) {
        this.formGroup.addControl(this.question.id.toString(), control);
        if (control.dirty && !this.formGroup.dirty) this.formGroup.markAsDirty();
      }
    }else {
      subgroup.questions.forEach( q=> {
        const control = makeControlForQuestion(q);
      if (control) {
        this.formGroup.addControl(q.id.toString(), control);
        if (control.dirty && !this.formGroup.dirty) this.formGroup.markAsDirty();
      }
      })

      this.columnOrdering = this.updateColumnOrdering();

      this.subGroup.rows.forEach((r, idx) => {
        r.ordinal = idx;
      });
    }

    switch (tab) {
      case 1: {
        if (category && category["validationWarnings"]) {
          let found
          if (subgroup.isTable) {
            found = category["validationWarnings"].find(
              w => subgroup.questions.some(q => q.id === w.id)
            );
          }else {
            found = category["validationWarnings"].find(
              w => w.id === question.id
            );
          }

          if (found) {
            this.question["validationWarning"] = found;
          }
        }
        this.answerWarnings = []
        if (subgroup.isTable) {
          subgroup.questions.forEach(q => {
            q.answers.forEach(a => this.initAnswerWarnings(a, q));
          });
        }else {
          question.answers.forEach(a => this.initAnswerWarnings(a, question));
        }
        break;
      }
      case 2: {
        this.initAnswerFlags = []
        if (subgroup.isTable) {
          subgroup.rows.forEach((r, rowIndex) => {
            Object.keys(r.cells).forEach(qId => {
              const cellAns = r.cells[qId].id;
              if (cellAns) {
                const q = subgroup.questions.find(q => q.id === Number(qId));
                this.initFlag(r.cells[qId], q, group, subgroup, rowIndex);
              }
            });
          });
        }else {
          question.answers.forEach(a =>
            this.initFlag(a, question, group, subgroup)
          )
        }

        break;
      }
      case 3: {
        this.comment = new UntypedFormControl('');
        this.comment.setValue('');
        this.comments = []
        this.documents = this.taxReturn.documents
        if (subgroup.isTable) {
          subgroup.questions.forEach(q => {
            this.initComment(q, group, subgroup)
          })
        }
        this.initComment(question, group, subgroup)
      }
      default:
        break

    }


  }

  goToSection(
    question: IFormField,
    category: Category,
    subcategory: Subcategory,
    group: IGroup,
    subgroup: ISubGroup
  ) {
    this.question = {
      ...question,
      category: category,
      subcategory: subcategory,
      group: group,
      subgroup: subgroup
    };
    window.open(`${this.baseUrl.get()}/tax-returns/${this.taxReturn.id}/subcategories/${subcategory.id}?question=${question.id}`);
  }

  initFlag(
    a: IAnswer,
    q: IFormField,
    group?: IGroup,
    subgroup?: ISubGroup,
    rowIndex?: number
  ) {
    if (!a.answerFlags || a.answerFlags.length === 0) return a;

    a.answerFlags = a.answerFlags.map(aF => {
      const answerFlag: any = {
        ...aF,
        answer: q.answers.find(a => a.id === aF.answerId),
        question: q,
        groupId: group ? group.id : null,
        subGroupId: subgroup ? subgroup.id : null,
        groupName: group
          ? group.deleted
            ? group.deletedName
            : group.name
          : null,
        subGroupName: subgroup ? subgroup.name : null,
        rowIndex: rowIndex,
        createdAtString: moment(aF.createdAt).format("MMMM Do YYYY, h:mm:ss a")
      };

      if (a.comments && a.comments.length > 0) {
        const flagComment = a.comments.find(
          c => c.answerFlagId === aF.id && !c.parentCommentId
        );
        if (flagComment) {
          answerFlag.parentComment = this.getCommentMeta(flagComment);
          // find replies to parent comment
          answerFlag.parentComment.comments = [];
          a.comments.forEach(cc => {
            if (cc.parentCommentId === answerFlag.parentComment.id)
              answerFlag.parentComment.comments.push(this.getCommentMeta(cc));
          });
          answerFlag.externalUrl = answerFlag.parentComment.comments.find(c => !!c.externalUrl)?.externalUrl;
        }
      }

      answerFlag.replyTo = false;
      if (this.showActiveAnswerWarnings) {
        this.initAnswerFlags.push(answerFlag)

      }else {
        if (answerFlag.status > 0) {
          this.initAnswerFlags.push(answerFlag)
        }
      }
      return answerFlag;
    });
    return a;
  }

  // get total active warnings count for a category or for all categories
  getWarningsCount(category?) {
    let count = 0;
    (category ? [category] : this.taxReturn.categories).forEach(c =>
      c.subcategories.forEach(
        sc => (count += getActiveWarnings(this.taxReturn, sc))
      )
    );
    return count;
  }

  getCommentMeta(c: IComment) {
    let user;
    let role;
    if (
      c.commentAudits &&
      c.commentAudits.length &&
      this.taxReturn &&
      this.taxReturn.preparer &&
      this.taxReturn.preparer.find(p => p.id === c.commentAudits[0].userId)
    ) {
      user = this.taxReturn.preparer.find(
        p => p.id === c.commentAudits[0].userId
      );
      role = "Preparer";
    } else if (
      c.commentAudits &&
      c.commentAudits.length &&
      this.taxReturn &&
      this.taxReturn.reviewer &&
      this.taxReturn.reviewer.find(p => p.id === c.commentAudits[0].userId)
    ) {
      user = this.taxReturn.reviewer.find(
        p => p.id === c.commentAudits[0].userId
      );
      role = "Reviewer";
    } else {
      user =
        c.commentAudits && c.commentAudits.length
          ? c.commentAudits[0]["user"]
          : null;
      role = "";
    }

    const author = user ? user.firstName + ' ' + user.lastName : (c.autoDocLink ? 'Auto generated' : 'Unknown User');
    role = role ? role : (c.autoDocLink ? 'System' : 'Unknown role');

    const m = moment(c.createdAt);
    return {
      id: c.id,
      message: c.message,
      parts: c.parts,
      author,
      role,
      date: m.format("MMMM Do YYYY, h:mm:ss a"),
      dateMoment: m,
      isReply: Boolean(c.parentCommentId)
    };
  }

  readonly() {
    return (
      !this.taxReturn ||
      this.taxReturn.snapshotId != null ||
      !this.taxReturn.assignedUser ||
      this.taxReturn.assignedUser.id !== this.userInfo.id ||
      this.taxReturn.assignee.status === 99 ||
      this.taxReturn.userIsReadOnly ||
      this.taxReturn.fullStatus.readOnly
    );
  }

  // submit a comment reply
  async replyToFlag(answerFlag: IAnswerFlag, closeFlag?: boolean) {
    const { attachments, success } = await this.attachmentsService.uploadAttachments(this.folders, this.subcategory.name, Array.from(answerFlag.replyComment.attachments.values()));
    if (!success) return;

    const _comment: any = {
      parentCommentId: answerFlag.parentComment.id,
      message: answerFlag.replyComment.message,
      attachments,
      answerIds: [answerFlag.answerId]
    };

    this.commentService.addComment(_comment).subscribe((response: any) => {
      let newComment = response.comment;
      if (
        newComment &&
        newComment.commentAudits &&
        newComment.commentAudits.length
      ) {
        newComment.commentAudits[0].user = response.user;
      }

      handleUrlsForNewComment(
        this.taxReturnService,
        this.taxReturn,
        newComment
      ).subscribe(() => {});

      // append reply to parent comment
      answerFlag.parentComment.comments.push(this.getCommentMeta(newComment));

      if (closeFlag) {
        this.answerService
          .updateAnswerFlag({
            answerFlagIds: [answerFlag.id],
            status: 99
          })
          .subscribe(() => {
            answerFlag.replyTo = false;
            answerFlag.replyComment = { message: "", attachments: new Map() };
            answerFlag.status = 99;
          });
      } else {
        answerFlag.replyTo = false;
        answerFlag.replyComment = { message: "", attachments: new Map() };
      }
    });
  }

  initAnswerWarnings(a: IAnswer, q: Question) {
    if (!a.answerWarnings || a.answerWarnings.length === 0) return a;

    a.answerWarnings = a.answerWarnings.map(answerWarning => {
      answerWarning = {
        ...answerWarning,
        answer: a,
        question: q.question
      };

      if (!answerWarning.createdAtString)
        answerWarning.createdAtString = moment(answerWarning.createdAt).format(
          "MMMM Do YYYY, h:mm:ss a"
        );

      // find comments on the warning
      answerWarning.replies = [];
      a.comments.forEach(c => {
        if (c.answerWarningId === answerWarning.id) {
          answerWarning.replies.push(this.getCommentMeta(c));
        }
      });
      answerWarning.externalUrl = answerWarning.replies.find(c => !!c.externalUrl)?.externalUrl;

      answerWarning.replyTo = false;
      answerWarning.replyComment = { message: "", attachments: new Map() };
      if (this.subGroup.isTable) {
        const rowIndex = this.subGroup.question ? this.subGroup.question.answers.map(a => a.id).indexOf(answerWarning.answer.parentAnswerId) + 1 : null
        answerWarning.rowIndex = rowIndex ? rowIndex : null;
      }
      if (this.showActiveAnswerWarnings) {
        this.answerWarnings.push(answerWarning);
      }else {
        if (answerWarning.status > 0) {
          this.answerWarnings.push(answerWarning);
        }
      }

      return answerWarning;
    });
    return a;
  }

  async saveAnsWarningReply(answerWarning: IAnswerWarning, comment: CommentValue, closeWarning: boolean) {
    const { attachments, success } = await this.attachmentsService.uploadAttachments(this.folders, this.subcategory.name, Array.from(comment.attachments.values()));
    if (!success) return;

    const _comment: any = {
      message: comment.message,
      attachments,
      answerIds: [answerWarning.answerId],
      answerWarningId: answerWarning.id
    };

    this.commentService.addComment(_comment).subscribe((response: any) => {
      let newComment = response.comment;
      if (
        newComment &&
        newComment.commentAudits &&
        newComment.commentAudits.length
      ) {
        newComment.commentAudits[0].user = response.user;
      }
      handleUrlsForNewComment(
        this.taxReturnService,
        this.taxReturn,
        newComment
      ).subscribe(() => {});

      answerWarning.answer.comments.push(newComment);

      if (closeWarning) {
        this.answerService.updateAnswerWarning({
          answerWarningIds: [answerWarning.id],
          status: 1
        }).subscribe(() => {
          answerWarning.replyTo = false;
          answerWarning.replyComment = { message: "", attachments: new Map() };
          answerWarning.status = 1; // cause the count to update immediately
          setTimeout(() => {
            this.selectQuestion(
              this.question,
              this.question.category,
              this.subcategory,
              this.question.group,
              this.subGroup,
              this.tab
            )
          });
        })
      }else {
        answerWarning.replyTo = false;
        answerWarning.replyComment = { message: "", attachments: new Map() };
        setTimeout(() => {
          this.selectQuestion(
            this.question,
            this.question.category,
            this.subcategory,
            this.question.group,
            this.subGroup,
            this.tab
          )
        });
      }
    });
  }

  // checks whether a question has any remaining active MI flags/warnings
  hasClosedAll(question) {
    return question.answers.every(
      a =>
        a.answerFlags.every(aF => aF.status !== 0) &&
        a.answerWarnings.every(aW => aW.status !== 0)
    );
  }

  selectTab(tab: number) {
    this.tab = tab;
    this.taxReturnSubcategoryService.selectTab(tab);
    this.initMissingInfo(this.taxReturn, this.tab);
    this.showActiveAnswerWarnings = true;
    this.question = null
    this.answerWarnings = []
    this.initAnswerFlags = []
    this.comments = []
  }

  // show comments for all answers, not just the most recent answer
  initComment(q: any, group?: any, subgroup?: any) {

    // finds the nearest answer audit relative the comment,
    // max 1 second either side of comment creation date
    const nearest = (answerAudits, comment: IComment) => {
      const commentWithNearestAudit = cloneDeep(comment);
      let closestMs = null;
      answerAudits.forEach(answerAudit => {
        const duration = moment.duration(moment(answerAudit.createdAt).diff(moment(comment.createdAt)));
        const durationMs = Math.abs(duration.asMilliseconds());
        if (durationMs < 2000 && (closestMs == null || durationMs < closestMs)) {
          // @ts-ignore - TODO fix types. comment type does not have a `nearestAudit` property
          commentWithNearestAudit.nearestAudit = cloneDeep(answerAudit);
          closestMs = durationMs;
        }
      });
      return commentWithNearestAudit;
    };

    if (q.answers && q.answers.length > 0) {

      q.answers.forEach((a, i) => {
        if ((a.comments || []).length > 0) {

          // start with top level comments
          a.comments.forEach(c => {

            // filter out answer warning and flag comments
            if (c.parentCommentId || c.answerWarningId || c.answerFlagId) return false;

            // note: tab questions will not return subgroup data
            const commentField: ICommentField = {
              id: q.id,
              question: q.question,
              groupId: group ? group.id : null,
              subGroupId: subgroup ? subgroup.id : null,
              groupName: group ? (group.deleted ? group.deletedName : group.name) : null,
              subGroupName: subgroup ? subgroup.name : null,
            };


            // append old/new answer to popup
            const ansAudits = a.answerAudits.filter(aA => aA.answerId === a.id);
            if (ansAudits.length > 1) {
              const commentWithNearestAudit = nearest(a.answerAudits, c);
              // @ts-ignore - TODO fix types. comment type does not have a `nearestAudit` property
              if (commentWithNearestAudit && commentWithNearestAudit.nearestAudit) {
              // @ts-ignore
                if (commentWithNearestAudit.nearestAudit.oldAnswer) {
              // @ts-ignore
                  commentField.valueChange = `(answer changed from '${commentWithNearestAudit.nearestAudit.oldAnswer}' to '${commentWithNearestAudit.nearestAudit.newAnswer}')`;
              // @ts-ignore
                } else if (commentWithNearestAudit.nearestAudit.newAnswer) {
              // @ts-ignore
                  commentField.valueChange = `(saved answer '${commentWithNearestAudit.nearestAudit.newAnswer}')`;
                }
              }
            }

            // append row for table questions
            if (subgroup.isTable) {
              const rowIndex = subgroup.rows.findIndex(r => r.cells[q.id].id === a.id);
              commentField.rowIndex = rowIndex;
            }

            // only append unique comments
            const commentInArr = this.comments.find(_c => _c.id === c.id);

            if (commentInArr) {
              commentInArr.commentFields.push(commentField);
            } else {
              const parentC: any = this.getCommentMeta(c);
              parentC.commentFields = [commentField];
              parentC.comments = [];
              this.comments.push(parentC);
            }

          });

          // now find all the replies to each comment
          a.comments.forEach(c => {
            if (c.parentCommentId && !c.answerWarningId) {
              const parentC = this.comments.find(_c => _c.id === c.parentCommentId);
              if (parentC && !parentC.comments.find(_c => _c.id === c.id)) {
                parentC.comments.push(this.getCommentMeta(c));
              }
            }
          });

        }

      });

    }
  }

  // submit a comment reply
  async saveCommentReply(comment: IComment) {
    const { attachments, success } = await this.attachmentsService.uploadAttachments(this.folders, this.subcategory.name, Array.from(comment.replyComment.attachments.values()));
    if (!success) return;

    this.isSavingReply = true;

    const _comment: any = {
      parentCommentId: comment.id,
      message: comment.replyComment.message,
      attachments,
      answerIds: []
    };

    this.subscriptions.push(this.commentService.addComment(_comment).subscribe((response: any) => {
      const newComment = response.comment;
      if (newComment && newComment.commentAudits && newComment.commentAudits.length) {
        newComment.commentAudits[0].user = response.user;
      }
      this.handleCommentReply(newComment);

      // push into comments replies arr
      const parentC = this.comments.find(_c => _c.id === newComment.parentCommentId);
      parentC.comments.push(this.getCommentMeta(newComment));

      this.isSavingReply = false;
      comment.replyTo = false;
      comment.replyComment = { message: "", attachments: new Map() };
      this.initTaxReturn()

      // this.commentReply.emit();
    },
      () => {
        this.isSavingReply = false;
      }));

  }

  handleCommentReply(newComment: IComment) {
    handleUrlsForNewComment(
      this.taxReturnService,
      this.taxReturn,
      newComment
    ).subscribe(() => {});
  };



  showSendToClientButton(info, question) {
    return false;
    // Hiding the send to client button, till the MI feature is supported.

    // if (this.tab === 1) {
    //   return (
    //     info.status === 0 &&
    //     question.displayFieldType !== 'table' &&
    //     !question.parentId &&
    //     !question.hidden &&
    //     this.visibleQuestions[question.id]
    //   )
    // }else if (this.tab === 2) {
    //   return (
    //     info.status === 0 &&
    //     question.displayFieldType !== 'table' &&
    //     !question.parentId &&
    //     info.flagId === 2 &&
    //     !info.question.hidden &&
    //     this.visibleQuestions[question.id]
    //   )
    // }else {
    //   return false
    // }
  }
  cancelReply(comment: IComment) {
    comment.replyTo = false;
    comment.replyComment = { message: "", attachments: new Map() };
  }

  updateFlag(value, tab) {
    this.showActiveAnswerWarnings = value;
    switch (tab) {
      case 1:
        for (const cat of this.taxReturnWithMissingInfo.categories) {
          this.hasWarnings = this.showActiveAnswerWarnings ?
            ((cat["validationWarnings"] && cat["validationWarnings"].length > 0) || cat["warningCount"]) :
            !!cat["closedWarningCount"];
          if (this.hasWarnings) break;
        }
        break;
      case 2:
        for (const cat of this.taxReturnWithMissingInfo.categories) {
          this.hasWarnings = this.showActiveAnswerWarnings ? !!cat["flagCount"] : !!cat["closedFlagCount"];
          if (this.hasWarnings) break;
        }
        break;
    }
    this.question = null
    this.answerWarnings = []
    this.initAnswerFlags = []
    this.comments = []
  }
}
